import {connect} from 'react-redux';

import {createStructuredSelector} from '../../../srcCommon/helpers/reselectHelpers';
import {getCompanyId} from '../../store/data/company/companySelectors';
import {getUserId} from '../../store/data/teammates/teammatesSelectors';
import {ErrorReporter} from './errorReporter';

/*
 * Redux.
 */

const mapStateToProps = createStructuredSelector({
  companyId: getCompanyId,
  userId: getUserId,
});

export const ErrorReporterContainer = connect(mapStateToProps)(ErrorReporter);
